<template>
  <div
    class="modal"
    style="display: block"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-sm-12">
              <span>
                {{ headerText }}
              </span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <slot name="body" />
        </div>
        <div class="modal-footer">
          <div
            v-if="mode === modalWindowTypes.DRAG"
            slot="footer"
          >
            <button
              class="btn btn-primary"
              @click="close()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  modalWindowTypes
} from '@/utils/dictionaries'

export default {
  name: 'Modal',
  props: {
    mode: {
      type: String,
      default: modalWindowTypes.ADD
    }
  },
  computed: {
    headerText() {
      switch (this.mode) {
        case modalWindowTypes.ADD:
          return 'Add new action'
        case modalWindowTypes.EDIT:
          return 'Edit action'
        case modalWindowTypes.DRAG:
          return `Move or Copy (Drag and Drop)`
        default:
          return 'Add new action'
      }
    },
    modalWindowTypes() {
      return modalWindowTypes
    }
  },
  methods: {
    add() {
      this.$emit('add')
    },
    save() {
      this.$emit('save')
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue